import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { issuesAPI } from '../../services/api';
import { LoadingPage } from '../../components/Loading';
import { useLanguage } from '../../context/LanguageContext';
import './Issues.css';

const IssueDetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { formatDate } = useLanguage();
  const [issue, setIssue] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchIssue();
  }, [slug]);

  const fetchIssue = async () => {
    try {
      setLoading(true);
      const response = await issuesAPI.getBySlug(slug);
      setIssue(response.data);
    } catch (error) {
      console.error('Error fetching service:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <LoadingPage message="載入服務詳情..." />;

  if (!issue) {
    return (
      <div className="container">
        <div className="error-message">
          <h2>找不到此服務項目</h2>
          <button onClick={() => navigate('/services')} className="btn btn-primary">
            返回核心服務
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="issue-detail-page">
      <div className="container">
        <button onClick={() => navigate('/services')} className="back-button">
          ← 返回核心服務
        </button>

        <article className="issue-detail">
          <header className="issue-header">
            <h1>{issue.title}</h1>
            <div className="issue-info">
              <span>📅 {formatDate(issue.created_at)}</span>
            </div>
          </header>

          {issue.featured_image && (
            <div className="issue-image">
              <img src={issue.featured_image} alt={issue.title} />
            </div>
          )}

          <div className="issue-content">
            <h2>服務介紹</h2>
            <div
              className="content-html"
              dangerouslySetInnerHTML={{ __html: issue.description }}
            />
          </div>

          {issue.current_status && (
            <div className="solution-section">
              <h2>現況與工作範疇</h2>
              <div
                className="content-html"
                dangerouslySetInnerHTML={{ __html: issue.current_status }}
              />
            </div>
          )}

          {issue.progress && (
            <div className="results-section">
              <h2>進展情況</h2>
              <div
                className="content-html"
                dangerouslySetInnerHTML={{ __html: issue.progress }}
              />
            </div>
          )}

          {issue.future_plans && (
            <div className="solution-section">
              <h2>未來展望</h2>
              <div
                className="content-html"
                dangerouslySetInnerHTML={{ __html: issue.future_plans }}
              />
            </div>
          )}

          <div className="issue-footer">
            <button onClick={() => navigate('/contact')} className="btn btn-primary">
              聯絡我們了解更多
            </button>
          </div>
        </article>
      </div>
    </div>
  );
};

export default IssueDetail;
